import { Card, Paper, styled } from "@mui/material";

const StyledCard = styled(Card)(({ theme }) => ({
  maxWidth: 1200,
  margin: "0 auto",
  borderRadius: theme.spacing(2),
  overflow: "visible",
}));

const EquipmentCard = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fafafa",
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.grey[200]}`,
}));

const NotesCard = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff8e1",
  border: "1px solid #ffecb3",
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
}));

export { EquipmentCard, NotesCard, StyledCard };
